import {
    createContext,
    useCallback,
    useContext,
    useEffect,
    useState
} from "react";

import API from "../api/api";


const AuthContext =
    createContext(null);


export function AuthProvider({
    children
}) {

    const [user, setUser] =
        useState(null);

    const [loading, setLoading] =
        useState(true);


    /*
    =====================================================
    LOAD CURRENT USER
    =====================================================
    */

    const refreshUser =
        useCallback(async () => {

            const token =
    localStorage.getItem("token") ||
    sessionStorage.getItem("token");


            if (!token) {

                setUser(null);
                setLoading(false);

                return;

            }


            try {

                const res =
                    await API.get(
                        "/auth/me"
                    );


                setUser(
                    res.data
                );


                /*
                =========================================
                OPTIONAL:
                keep sessionStorage user updated
                =========================================
                */

                const storage =
    localStorage.getItem("token")
        ? localStorage
        : sessionStorage;

storage.setItem(
    "user",
    JSON.stringify(res.data)
);


            } catch (err) {

                console.error(
                    "Unable to load current user:",
                    err
                );


                setUser(null);


            } finally {

                setLoading(false);

            }

        }, []);


    /*
    =====================================================
    INITIAL LOAD
    =====================================================
    */

    useEffect(() => {

        refreshUser();

    }, [refreshUser]);


    /*
    =====================================================
    PERMISSION CHECK
    =====================================================
    */

    const hasPermission =
        useCallback(
            (permission) => {

                if (!user) {
                    return false;
                }


    

                const permissions =
                    Array.isArray(
                        user.permissions
                    )
                        ? user.permissions
                        : [];


                /*
                Super admin automatically
                has every permission.
                */

                if (
                    permissions.includes(
                        "super_admin"
                    )
                ) {
                    return true;
                }


                return permissions.includes(
                    permission
                );

            },
            [user]
        );


    /*
    =====================================================
    CONTEXT
    =====================================================
    */

    return (

        <AuthContext.Provider
            value={{
                user,
                loading,
                hasPermission,
                refreshUser,
                setUser
            }}
        >

            {children}

        </AuthContext.Provider>

    );

}


/*
=====================================================
HOOK
=====================================================
*/

export function useAuth() {

    const context =
        useContext(
            AuthContext
        );


    if (!context) {

        throw new Error(
            "useAuth must be used inside AuthProvider"
        );

    }


    return context;

}